import { call, put, select, takeLatest } from 'redux-saga/effects'

import { ToastTemplateTicked, ToastTemplateWarning } from '@components/UI/ToastTemplate'
import { selectAuthToken } from '@store/auth'
import {
  activateWithFee,
  ActivateWithFeeActionTypes,
  activateWithFeeError,
  activateWithFeeSuccess,
  fetchCampaigns,
  IActivateWithFeeResponse,
  ICampaign,
  selectActivateWithFeeLink,
} from '@store/campaigns'
import { Toaster } from '@tribegroup'
import { networkRequest, selectLink } from '@utils'

export function* handlePaymentFailure(response: IActivateWithFeeResponse, authToken: string) {
  const abandon3dsLink = selectLink(response.links, 'abandon_activation_with_fee')

  yield call(
    networkRequest,
    abandon3dsLink?.method,
    abandon3dsLink?.href,
    { payment_intent_id: response.payment_intent_id },
    authToken,
  )
}

export function* handlePaymentRequest(action: ReturnType<typeof activateWithFee>) {
  const { campaignId } = action.payload
  const authToken = yield select(selectAuthToken)
  const activateWithFeeLink = yield select(selectActivateWithFeeLink, campaignId)

  const activateWithFeeResponse: IActivateWithFeeResponse = yield call(
    networkRequest,
    activateWithFeeLink.method,
    activateWithFeeLink.href,
    undefined,
    authToken,
  )

  if (!activateWithFeeResponse.brief) {
    throw new Error('Invalid state: Brief should be present in response')
  }

  return activateWithFeeResponse.brief
}

export function* handleActivateWithFee(action: ReturnType<typeof activateWithFee>) {
  try {
    const campaign: ICampaign = yield call(handlePaymentRequest, action)

    yield put(activateWithFeeSuccess(campaign))
    yield put(fetchCampaigns())
    yield call(Toaster.createToast, ToastTemplateTicked, {
      i18nKey: 'campaign.card.activateWithFee.toast.success',
    })
  } catch (error) {
    yield put(activateWithFeeError(error))
    yield call(Toaster.createToast, ToastTemplateWarning, {
      i18nKey: 'campaign.card.activateWithFee.toast.error',
    })
  }
}

export function* watchActivateWithFeeRequest() {
  yield takeLatest(ActivateWithFeeActionTypes.ACTIVATE_WITH_FEE_REQUEST, handleActivateWithFee)
}
